module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-plus-7f96dd9e.svg";